<div class="ml-5">
  <p id="gestion-des-parcours" class="titre1 m-4">
    {{ 'LEARNING_PATH_MANAGEMENT.LEARNING_PATH_MANAGEMENT' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-2 float-right">conversion_path</mat-icon>
  </p>
  <div class="overflow-x-auto">
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="flex justify-end mb-4">
        <button (click)="createParcours()"  class="btn-primary-novo">
          {{ 'LEARNING_PATH_MANAGEMENT.CREATE_LEARNING_PATH' | translate }}
        </button>
      </div>
      <div class="flex justify-end mb-4 gap-3">
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
          placeholder="{{ 'LEARNING_PATH_MANAGEMENT.SEARCH' | translate }}..."
          class="h-1/5 w-80 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="reinitialiserFiltre()"
            class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <div class="w-full overflow-x-auto">
          <table mat-table [dataSource]="dataSource" matSort class="min-w-full mat-table-novo"
            (matSortChange)="sortDataChange($event)">
            <ng-container matColumnDef="nom">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-3/5 table-cell px-4 py-2">
                {{ 'LEARNING_PATH_MANAGEMENT.NAME' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-3/5 table-cell px-4 py-2 border-b">
                {{ parcoursService.getNomLocaliseFromLocales(element.locales) }}
                @if (element.estRecurrent && element.recurrenceEnAnnees) {
                  <span class="ml-2 px-2 py-0.5 text-xs rounded-full bg-gray-200 text-gray-700 whitespace-nowrap">
                    {{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE_BADGE' | translate: { count: element.recurrenceEnAnnees } }}
                  </span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="totalModules">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-1/5 table-cell px-4 py-2">
                {{ 'LEARNING_PATH_MANAGEMENT.TOTAL_MODULES' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-1/5 table-cell px-4 py-2 border-b">
                {{ element.totalPackages }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dateCreation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-1/5 table-cell px-4 py-2">
                {{ 'LEARNING_PATH_MANAGEMENT.CREATION_DATE' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-1/5 table-cell px-4 py-2 border-b">
                {{ element.dateCreation | dateFormat }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="w-1/100 table-cell px-4 py-2 text-center">
                {{ 'LEARNING_PATH_MANAGEMENT.ACTIONS' | translate }}
              </th>
              <td mat-cell *matCellDef="let element"
                class="w-1/100 table-cell px-4 py-2 border-b text-center">
                <div class="menu-container">
                  <button (click)="toggleMenu(element)"
                    class="bg-grey-500 hover:bg-grey-700 font-bold py-2 px-4 border-none hover:text-red-700 transform scale-90 sm:scale-100">
                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                  </button>
                  @if (element.isMenuOpen) {
                    <div
                      class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                      <div class="py-1" role="menu" aria-orientation="vertical"
                        aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="editParcours(element)">
                          {{ 'LEARNING_PATH_MANAGEMENT.EDIT' | translate }}
                        </a>
                      </div>
                      <div class="py-1" role="menu" aria-orientation="vertical"
                        aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="deleteParcours(element)">
                          {{ 'LEARNING_PATH_MANAGEMENT.REMOVE' | translate }}
                        </a>
                      </div>
                      <div class="py-1" role="menu" aria-orientation="vertical"
                        aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="exporterParcours(element)">
                          {{ 'LEARNING_PATH_MANAGEMENT.EXPORT_EXCEL' | translate }}
                        </a>
                      </div>
                    </div>
                  }
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          @if (dataSource.filteredData.length === 0) {
            <div class="text-center mt-2 text-gray-500">
              {{ 'LEARNING_PATH_MANAGEMENT.NO_RESULTS' | translate }}
            </div>
          }
          <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
            (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
      }
    </div>
  </div>
